import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "capabilities-section" }
const _hoisted_2 = { class: "section-header container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { class: "capabilities container" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["innerHTML"]

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { icons } from '../icons';

interface CapabilityItem {
    icon: keyof typeof icons;
    titleKey: string;
    descriptionKey: string;
    route: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Capabilities',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

const capabilityList: CapabilityItem[] = [
    {
        icon: 'engineering',
        titleKey: 'Capabilities.items.metallurgical.title',
        descriptionKey: 'Capabilities.items.metallurgical.description',
        route: '/engineering'
    },
    {
        icon: 'metalCasting',
        titleKey: 'Capabilities.items.metalCasting.title',
        descriptionKey: 'Capabilities.items.metalCasting.description',
        route: '/casting'
    },
    {
        icon: 'heatTreatment',
        titleKey: 'Capabilities.items.heatTreatment.title',
        descriptionKey: 'Capabilities.items.heatTreatment.description',
        route: '/hot-chamber-casting'
    },
    {
        icon: 'cncMachining',
        titleKey: 'Capabilities.items.cncMachining.title',
        descriptionKey: 'Capabilities.items.cncMachining.description',
        route: '/cnc-machining'
    },
    {
        icon: 'manufacturing',
        titleKey: 'Capabilities.items.manufacturing.title',
        descriptionKey: 'Capabilities.items.manufacturing.description',
        route: '/assembly-and-testing'
    },
    {
        icon: 'testingAnalysis',
        titleKey: 'Capabilities.items.testing.title',
        descriptionKey: 'Capabilities.items.testing.description',
        route: '/post-processing'
    }
];

const handleClick = (route: string) => {
    router.push(route);
};

const isReady = ref(false);

// 使用 requestIdleCallback 在浏览器空闲时渲染详细内容
onMounted(() => {
    if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
            isReady.value = true;
        });
    } else {
        // 降级处理
        setTimeout(() => {
            isReady.value = true;
        }, 0);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)('Capabilities.title')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('Capabilities.subtitle')), 1)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(capabilityList, (item) => {
        return _createElementVNode("div", {
          key: item.titleKey,
          class: "capability-item",
          onClick: ($event: any) => (handleClick(item.route))
        }, [
          _createElementVNode("div", {
            class: "icon-wrapper",
            innerHTML: _unref(icons)[item.icon]
          }, null, 8, _hoisted_7),
          _createElementVNode("h3", null, _toDisplayString(_unref(t)(item.titleKey)), 1),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "divider" }, null, -1)),
          _createElementVNode("p", null, _toDisplayString(_unref(t)(item.descriptionKey)), 1)
        ], 8, _hoisted_6)
      }), 64))
    ], 512), [
      [_vShow, isReady.value]
    ])
  ]))
}
}

})